import { CONTRACT_PROGRESS_CREDENTIALS_UPDATE } from '@app/store/actionTypes';
import { ContractProgressAction } from '@app/store/contract-progress/actions';

type ContractProgressAuthenticationKeyState = string | null;

const initialState: ContractProgressAuthenticationKeyState = null;

export default function reducer(
  state: ContractProgressAuthenticationKeyState = initialState,
  action: ContractProgressAction
) {
  switch (action.type) {
    case CONTRACT_PROGRESS_CREDENTIALS_UPDATE:
      return action.payload.authenticationKey;
    default:
      return state;
  }
}
